//SalesRuleFieldNames
const SEQUENCE_NUMBER = "sequenceNumber";
const APPLIES_TO = "appliesTo";
export const MATCHER = "matcher";
const MATCHING_VALUE = "matchingValue";
const MATCHING_META_FIELD = "matchingMetafield";
const MATCHING_PRODUCT_META_FIELD = "matchingProductMetafield";
const LINE_ITEM_MATCHER = "lineItemMatcher";
const LINE_ITEM_MATCHER_TYPE = "lineItemMatcherType";
const LINE_ITEM_MATCHING_VALUE = "lineItemMatchingValue";
const VAT_MAPPING_RULE_VALUE = "vatMappingRuleValue";
const MAPPED_ACCOUNT = "mappedAccount";
const KOST_1 = "kost1";
const KOST_2 = "kost2";
const BOOKING_CODE = "bookingCode";
const REVENUE_TYPE = "revenueType";
const OSS_START_DATE = "ossStartDate";

//SalesItemMatcherStatics
const EQUALS = "EQUALS";
const CONTAINS = "CONTAINS";
const CONTAINS_ONE_OF = "CONTAINS_ONE_OF";
const STARTS_WITH = "STARTS_WITH";
const ENDS_WITH = "ENDS_WITH";
const IS_BLANK = "IS_BLANK";

//SalesItemFieldStatics
const ANY = "ANY";
const AMAZON_MARKETPLACE = "AMAZON_MARKETPLACE";
const ZALANDO_MARKETPLACE = "ZALANDO_MARKETPLACE";
const B2B = "B2B";
const CONTACT_EMAIL = "CONTACT_EMAIL";
const COUNTRY_TYPE = "COUNTRY_TYPE";
const COUNTRY_CODE = "COUNTRY_CODE";
const COUNTRY_STATE = "COUNTRY_STATE";
const CUSTOM_FIELD_INVOICE = "CUSTOM_FIELD_INVOICE";
const CUSTOM_FIELD_SUBSCRIPTION = "CUSTOM_FIELD_SUBSCRIPTION";
const CUSTOM_FIELD_CUSTOMER = "CUSTOM_FIELD_CUSTOMER";
const CUSTOMER_ID = "CUSTOMER_ID";
const CUSTOMER_META_HV_ACTIVE = "CUSTOMER_META_HV_ACTIVE";
const CUSTOMER_META_HV_EXHAUSTED = "CUSTOMER_META_HV_EXHAUSTED";
const DEBITOR_NAME = "DEBITOR_NAME";
const DEBITOR_MAIL = "DEBITOR_MAIL";
const DEPOSIT = "DEPOSIT";
const DEBITOR_STRIPE_CUSTOMER_ID = "DEBITOR_STRIPE_CUSTOMER_ID";
const DEBITOR_STRIPE_CUSTOMER_DESCRIPTION = "DEBITOR_STRIPE_CUSTOMER_DESCRIPTION";
const DUTIES = "DUTIES";
const GIFT_CARD = "GIFT_CARD";
const GIFT_CARD_DISCOUNTS = "GIFT_CARD_DISCOUNTS";
const GIFT_CARD_EXPIRED = "GIFT_CARD_EXPIRED";
const GIFT_CARD_MANUAL = "GIFT_CARD_MANUAL";
const LINE_ITEM_DESCRIPTION = "LINE_ITEM_DESCRIPTION";
const METAFIELD_CUSTOMER = "METAFIELD_CUSTOMER";
const METAFIELD_INVOICE = "METAFIELD_INVOICE";
const METAFIELD_ITEM = "METAFIELD_ITEM";
const METAFIELD_ITEMPRICE = "METAFIELD_ITEMPRICE";
const METAFIELD_PLAN = "METAFIELD_PLAN";
const METAFIELD_SUBSCRIPTION = "METAFIELD_SUBSCRIPTION";
const METAFIELD_PRODUCT = "METAFIELD_PRODUCT";
const METAFIELD_PRODUCT_VARIANT = "METAFIELD_PRODUCT_VARIANT";
const METAFIELD_LOCATION = "METAFIELD_LOCATION";
const METAFIELD_ORDER = "METAFIELD_ORDER";
const METAFIELD_PRODUCT_CATEGORY = "METAFIELD_PRODUCT_CATEGORY";
const METAFIELD_REVENUE_CATEGORY = "METAFIELD_REVENUE_CATEGORY";
const METAFIELD_ENTITY_ID = "METAFIELD_ENTITY_ID";
const METAFIELD_LINE_ITEM = "METAFIELD_LINE_ITEM";
const ORIGIN_LOCATION = "ORIGIN_LOCATION";
const ORIGIN_LOCATION_COUNTRY_TYPE = "ORIGIN_LOCATION_COUNTRY_TYPE";
const ORIGIN_LOCATION_COUNTRY_CODE = "ORIGIN_LOCATION_COUNTRY_CODE";
const ORDER_NAME = "ORDER_NAME";
const ORDER_TAG = "ORDER_TAG";
const SHIPPING_RETURN_FEE = "SHIPPING_RETURN_FEE";
const OSS = "OSS";
const PLATFORM_DISCOUNT_TYPE = "PLATFORM_DISCOUNT_TYPE";
const PRODUCT_ID = "PRODUCT_ID";
const PRODUCT_TAG = "PRODUCT_TAG";
const PRODUCT_TYPE = "PRODUCT_TYPE";
const PROMO_PARTNER_META_FIELD = "PROMO_PARTNER_META_FIELD";
const PAYMENT_TYPE = "PAYMENT_TYPE";
const SELLER_DISCOUNT_TYPE = "SELLER_DISCOUNT_TYPE";
const SINGLE_DEBITOR_META_FIELD = "SINGLE_DEBITOR_META_FIELD";
const SKU = "SKU";
const SOURCE_NAME = "SOURCE_NAME";
const STATUS = "STATUS";
const STRIPE_BILLING_META_FIELD = "STRIPE_BILLING_META_FIELD";
const TAGS = "TAGS";
const TAGS_IMMEDIATE_FILTER = "TAGS_IMMEDIATE_FILTER";
const PROCESSED_AT_IMMEDIATE_FILTER = "PROCESSED_AT_IMMEDIATE_FILTER";
const TIP = "TIP";
const VAT = "VAT";
const REASON_CODE = "REASON_CODE";

//PlanRuleSelectors
const LINE_ITEM_PLAN_NAME = "LINE_ITEM_PLAN_NAME";
const LINE_ITEM_PRODUCT_NAME = "LINE_ITEM_PRODUCT_NAME";

//SalesRuleRevenueTyps
const RECURRING = "RECURRING";
const RECURRING_MONTHLY = "RECURRING_MONTHLY";
const RECURRING_3_MONTHLY = "RECURRING_3_MONTHLY";
const RECURRING_6_MONTHLY = "RECURRING_6_MONTHLY";
const RECURRING_YEARLY = "RECURRING_YEARLY";
const ONE_TIME = "ONE_TIME";

//SalesItemVALUEStatics
const EU_WITH_DE = "EU_WITH_DE";

export const SalesRuleFieldNames = {
    SEQUENCE_NUMBER,
    APPLIES_TO,
    MATCHER,
    MATCHING_META_FIELD,
    MATCHING_PRODUCT_META_FIELD,
    MATCHING_VALUE,
    LINE_ITEM_MATCHER,
    LINE_ITEM_MATCHER_TYPE,
    LINE_ITEM_MATCHING_VALUE,
    VAT_MAPPING_RULE_VALUE,
    MAPPED_ACCOUNT,
    KOST_1,
    KOST_2,
    BOOKING_CODE,
    REVENUE_TYPE,
    OSS_START_DATE,
};

export const SalesItemMatcher = {
    EQUALS,
    CONTAINS,
    CONTAINS_ONE_OF,
    STARTS_WITH,
    ENDS_WITH,
    IS_BLANK,
};

export const SalesItemField = {
    ANY,
    AMAZON_MARKETPLACE,
    ZALANDO_MARKETPLACE,
    B2B,
    CONTACT_EMAIL,
    COUNTRY_TYPE,
    COUNTRY_CODE,
    COUNTRY_STATE,
    CUSTOM_FIELD_INVOICE,
    CUSTOM_FIELD_SUBSCRIPTION,
    CUSTOM_FIELD_CUSTOMER,
    CUSTOMER_ID,
    CUSTOMER_META_HV_ACTIVE,
    CUSTOMER_META_HV_EXHAUSTED,
    DEBITOR_NAME,
    DEBITOR_MAIL,
    DEBITOR_STRIPE_CUSTOMER_ID,
    DEBITOR_STRIPE_CUSTOMER_DESCRIPTION,
    DEPOSIT,
    DUTIES,
    GIFT_CARD,
    GIFT_CARD_DISCOUNTS,
    GIFT_CARD_EXPIRED,
    GIFT_CARD_MANUAL,
    LINE_ITEM_DESCRIPTION,
    METAFIELD_CUSTOMER,
    METAFIELD_INVOICE,
    METAFIELD_ITEM,
    METAFIELD_ITEMPRICE,
    METAFIELD_PLAN,
    METAFIELD_PRODUCT,
    METAFIELD_PRODUCT_VARIANT,
    METAFIELD_LOCATION,
    METAFIELD_ORDER,
    METAFIELD_SUBSCRIPTION,
    ORIGIN_LOCATION,
    ORIGIN_LOCATION_COUNTRY_TYPE,
    ORIGIN_LOCATION_COUNTRY_CODE,
    ORDER_NAME,
    ORDER_TAG,
    SHIPPING_RETURN_FEE,
    PAYMENT_TYPE,
    PLATFORM_DISCOUNT_TYPE,
    PRODUCT_ID,
    PRODUCT_TAG,
    PRODUCT_TYPE,
    PROMO_PARTNER_META_FIELD,
    SINGLE_DEBITOR_META_FIELD,
    SELLER_DISCOUNT_TYPE,
    SOURCE_NAME,
    SKU,
    STATUS,
    STRIPE_BILLING_META_FIELD,
    OSS,
    TAGS,
    TAGS_IMMEDIATE_FILTER,
    TIP,
    VAT,
    PROCESSED_AT_IMMEDIATE_FILTER,
    REASON_CODE,
};

export const PlanRuleSelectors = {
    LINE_ITEM_PLAN_NAME,
    LINE_ITEM_PRODUCT_NAME,
    LINE_ITEM_DESCRIPTION,
    METAFIELD_PRODUCT_CATEGORY,
    METAFIELD_REVENUE_CATEGORY,
    METAFIELD_ENTITY_ID,
    METAFIELD_LINE_ITEM,
};

export const SalesRuleRevenueTyps = {
    RECURRING,
    RECURRING_MONTHLY,
    RECURRING_3_MONTHLY,
    RECURRING_6_MONTHLY,
    RECURRING_YEARLY,
    ONE_TIME,
    ANY,
};

export const SalesItemValue = {
    EU_WITH_DE,
};

export const BOOK_PER_LINE_ITEM_FIELDS = [PRODUCT_TAG, PRODUCT_TYPE, SKU, METAFIELD_PRODUCT];

// Fields whose account is assigned dynamically during the import, so no Konto is entered on the rule.
// Mirrors ImportAccountingRuleDto.needsMappedAccount() in commons, which rejects a saved configuration
// whose rules are missing an account — keep both in sync.
export const FIELDS_WITHOUT_MAPPED_ACCOUNT = [
    CUSTOM_FIELD_SUBSCRIPTION,
    CUSTOM_FIELD_CUSTOMER,
    SINGLE_DEBITOR_META_FIELD,
    PROMO_PARTNER_META_FIELD,
    DEBITOR_STRIPE_CUSTOMER_ID,
    DEBITOR_STRIPE_CUSTOMER_DESCRIPTION,
    METAFIELD_INVOICE,
    METAFIELD_CUSTOMER,
];
